export const OrderHistoryEndpoint = {
    orderHistory: `${process.env.API_BACKEND}/v1/history/order/`,
} as const
